import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from 'src/app/services/customer.service';
import Swal from "sweetalert2";
@Component({
  selector: 'app-account-info-update',
  templateUrl: './account-info-update.component.html',
  styleUrls: ['./account-info-update.component.scss']
})
export class AccountInfoUpdateComponent implements OnInit {
spin: boolean;
response: any[] = [];
  extendedaccountinfo: any = {};
  constructor(public dialog: MatDialogRef<AccountInfoUpdateComponent>,
    private customerService: CustomerService,
  ) { }

  ngOnInit(): void {
        this.spin = true;
    this.customerService.getaccountinfo(this.customerService.currentCustomer.PersonCompanyId).subscribe(data => {
      this.spin = false;
          
           this.extendedaccountinfo=data;

          
      
    });
  }
  closeDialog() {
    this.dialog.close();
  }
  dataChanged($event, sectionId,item) {
item.ATTRIBUTEVALUE=$event;

const index=this.response.findIndex((res)=>
res.ATTRIBUTENAME===item.ATTRIBUTENAME
);
if (index!==-1){
  this.response.splice(index,1);
}
this.response.push({...item});

  }
  saveadditionalinfo(){
  
    let res = {EXTENDEDACCOUNTINFO:this.response}
  
     this.customerService.updateaccountinfo(res,this.customerService.currentCustomer.PersonCompanyId).subscribe(res => {
  
       if (!res.Action) {
          Swal.fire({
                           title: res.Message,
                           icon: "success",
                           confirmButtonText: "OK",
                            });
         }  else {
Swal.fire({
                  title: res.Message,
                  icon: "info",
                  confirmButtonText: "OK",
                });
         }
      
    });
  }
}
